import React from 'react'
import "./header.css"
import { NavLink } from "react-router-dom";
import mainLogo from "../../images/mainLogo.png"
import mobileMainLogo from "../../images/mobileMainLogo.png"

function Header({ winners }) {

    const ageGate = localStorage.getItem("ageGate")

    return (
        <header className="header">
            <img src={mainLogo}
                className="mainLogo" />

            <img src={mobileMainLogo}
                className='mobileMainLogo' />


            <div className="tabList">
                <NavLink to="/unesi-kod" style={{ pointerEvents: 'none', color: "rgba(0, 0, 0, 0.329)" }}>УЧЕСТВУЈ</NavLink>
                <NavLink to="/mehanizam" style={{ pointerEvents: 'none', color: "rgba(0, 0, 0, 0.329)"  }}>МЕХАНИЗАМ</NavLink>
                <NavLink to="/nagrade" style={{ pointerEvents: 'none', color: "rgba(0, 0, 0, 0.329)"  }}>НАГРАДЕ</NavLink>
                <NavLink to="/pravila" style={{ pointerEvents: 'none', color: "rgba(0, 0, 0, 0.329)"  }}>ПРАВИЛА</NavLink>
                <NavLink to="/pitanja-i-odgovori" style={{ pointerEvents: 'none', color: "rgba(0, 0, 0, 0.329)"  }}>ПИТАЊА И ОДГОВОРИ</NavLink>
                <NavLink to="/dobitnici" style={{
                    pointerEvents: (ageGate === "true" && !Array.isArray(winners) == true) ? "" : 'none',
                    color: (ageGate === "true" && !Array.isArray(winners) == true) ? "" : "rgba(0, 0, 0, 0.329)"
                }}>
                    ДОБИТНИЦИ</NavLink>
            </div>
        </header>
    )
}

export default Header